'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useHamburger_unstable", {
    enumerable: true,
    get: function() {
        return useHamburger_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactbutton = require("@fluentui/react-button");
const _reacticons = require("@fluentui/react-icons");
const useHamburger_unstable = (props, ref)=>{
    return (0, _reactbutton.useButton_unstable)({
        icon: /*#__PURE__*/ _react.createElement(_reacticons.Navigation20Filled, null),
        appearance: 'transparent',
        ...props
    }, ref);
};
